import { Route } from "react-router-dom";
import { LaunchGap } from "./components";
import { Exchange } from "./components/Exchange";
import { Wickets9 } from "./components/Wickets9";
import SportsbookPlus from "./components/BetBy";
import { Casino } from "./components/Casino";
import { GameLaunch } from "./components/GameLaunch";
export default function GameRoutes() {
  return (
    <>
      <Route path="bharatsportsbook" element={<LaunchGap />} />
      <Route path="exchange" element={<Exchange />} />
      <Route path="exchange/Wickets9" element={<Wickets9 />} />
      <Route path="sportsbookplus" element={<SportsbookPlus />} />
      <Route path="casino/*" element={<Casino />} />
      <Route path="gamelaunch" element={<GameLaunch />} />
    </>
  );
}
